import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./redux/store"; // Import both store and persistor
import App from "./App";

ReactDOM.render(
  
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById("root"),
  
);
